import React from 'react';
import PropTypes from 'prop-types';
import "./index.css";
import classNames from "classnames";
import assets from "../../util/assets";

LabelFormField.propTypes = {
    type: PropTypes.string,
    disabled: PropTypes.bool,
    label: PropTypes.string.isRequired,
    value: PropTypes.string.isRequired,
    onClick: PropTypes.func,
};

LabelFormField.defaultProps = {
    type: "label",
    disabled: false,
    label: "label",
    value: "value",
};

function LabelFormField(props) {
    if (props.type === "label") {
        return (
            <div className="label-form-field-container">
                <div className="label-form-field-container-label">{props.label}</div>
                <div className="label-form-field-container-value">{props.value}</div>
            </div>
        );
    } else if (props.type === "dropdown") {

        const dropdownClass = classNames("label-form-field-container-value",
            "label-form-field-container-dropdown", {
                "label-form-field-container-dropdown-enable": !props.disabled,
                "label-form-field-container-dropdown-disabled": props.disabled
            })
        return (
            <div className="label-form-field-container">
                <div className="label-form-field-container-label">{props.label}</div>
                <div className={dropdownClass}
                     onClick={props.onClick}>
                    <span>{props.value}</span>
                    <img src={assets.broadcaster.profile.dropdown}/>
                </div>
            </div>
        );
    }
}

export default LabelFormField;